import React from 'react';

import {Box} from '@chakra-ui/react';

import {LoaderSpinner} from '../../components/LoaderSpinner';
import {UserPicker} from '../../components/UserPicker/UserPicker';
import {CalendarFilter} from '../../slices/calendarFilterSlice';
import {TourFilter} from '../../types/tours';
import {FiltersUsers, User} from '../../types/users';

interface IUserList {
  users: User[];
  listUsers: FiltersUsers[];
  userSelected: CalendarFilter[] | TourFilter[];
  isLoading: boolean;
  onChangeUser: (user: FiltersUsers, parent: string[]) => void;
  /** Proyecto seleccionado; si está vacío se pide elegir uno. */
  selectProject?: string;
  /** Reinicia el drill del picker (p. ej. proyecto/país). */
  resetKey?: unknown;
  /** Slot opcional por fila (p. ej. badge de eventos). */
  renderRowAccessory?: (item: FiltersUsers) => React.ReactNode;
}

export function UserList(props: IUserList) {
  const {
    users,
    listUsers,
    userSelected,
    isLoading,
    onChangeUser,
    selectProject,
    resetKey,
    renderRowAccessory,
  } = props;

  if (isLoading) {
    return <LoaderSpinner />;
  }
  if (!selectProject) {
    return (
      <Box py={6} textAlign='center' color='gray.500' fontSize='sm'>
        Selecciona un proyecto
      </Box>
    );
  }
  if (users.length == 0) {
    return (
      <Box py={6} textAlign='center' color='gray.500' fontSize='sm'>
        No hay usuarios en este proyecto
      </Box>
    );
  }

  const selected = userSelected[0]?.user as FiltersUsers | undefined;
  return (
    <UserPicker<FiltersUsers>
      items={listUsers}
      selectedId={selected?.id}
      initialParents={userSelected[0] ? userSelected[0].parents ?? [] : null}
      resetKey={resetKey}
      renderRowAccessory={renderRowAccessory}
      onSelect={(user, parents) => onChangeUser(user, parents)}
    />
  );
}
